/**
 * @desc 创建退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsRefundOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asRefundOrder/createRefundOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
